<template>
  <div>
  <v-spacer></v-spacer>
    <ArtSlider></ArtSlider>
  </div>
</template>

<script>
import ArtSlider from '../components/ArtSlider'
export default {
  name: 'DanSchmidt',
  components: {
    ArtSlider
  },
  data () {
      return {}
  }
}
</script>

<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
